<template>
    <v-app>
        <component :is="resolveLayoutVariant">
            <!--    <v-slide-x-transition mode="out-in">-->
            <!--        <transition name="transition" mode="out-in" appear>-->
            <router-view v-if="!(not_found || forbidden)"></router-view>
            <page-not-found v-else-if="not_found"></page-not-found>
            <page-forbidden v-else-if="forbidden"></page-forbidden>

            <!--        </transition>-->
            <!--    </v-slide-x-transition>-->
        </component>
    </v-app>
</template>

<script>
import PageNotFound from "@/pages/Page/PageNotAllowed.vue";
import PageForbidden from "@/pages/Page/PageForbidden.vue";

export default {
    name: 'App',

    components: {
        PageForbidden,
        PageNotFound,
        LayoutBase: () => import('@/layouts/LayoutBase'),
        LayoutNavbar: () => import('@/layouts/LayoutNavbar'),
        LayoutContent: () => import('@/layouts/LayoutContent'),
    },
    async mounted() {
        this.$store.commit('setPeriodTypes', [
            {
                id: 2,
                title: this.$t('basics.price_hourly'),
                value: "price_hourly"
            },
            {
                id: 3,
                title: this.$t('basics.price_daily'),
                value: "price_daily"
            },
            {
                id: 4,
                title: this.$t('basics.price_monthly'),
                value: "price"
            },])
      if (this.$store.getters.token && !["/email/verification/success", "/email/verification/pending", "/email/verification/not-verified", "/one-id/impersonate", "/token/impersonate"].includes(window.location.pathname)) {
            let res = await this.$store.dispatch('check_me', this.$store.getters.token)
        if (res.ok && this.$route.name === 'login')
                this.$router.push("/")
            this.$i18n.locale = this.$store.getters?.locale ??  "uz"
            this.$vuetify.theme.dark = this.$store.getters.auth_user?.theme === "dark"
            this.$vuetify.theme.light = this.$store.getters.auth_user?.theme === "light"
        } else {
            if (!["/login", "/login?", "/github-sign-in","/email/forgot-password", "/one-id/impersonate", "/token/impersonate"].includes(window.location.pathname))
                this.$router.push('/login')
            else{
                console.log(1111);
            }
        }
    }
    ,
    data() {
        return {
            not_found: false,
            forbidden: false,
        }
    }
    ,
    watch: {
        $route: {
            immediate: true,
            handler(to) {
                document.title = this.$t(to.meta.title) || 'Unicon.uz';
                this.not_found = false
                this.forbidden = false
            }
        }
        ,
    }
    ,
    methods: {}
    ,
    computed: {
          resolveLayoutVariant() {
            if (this.$route.meta.layout == 'content')
                return 'layout-content'
            if (this.$route.meta.layout == 'base')
              return 'layout-base'
            return 'layout-navbar'
        }
    }
    ,
}
;
</script>
<style>

</style>